<template>
  <div class="ah-visually-hidden">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'visually-hidden',
  }
</script>

<style lang="scss" scoped>
  .ah-visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
</style>